/**
 * Redux witness watchers for content-filters
 * @module services/content-filters/watchers
 */
import { List } from 'immutable'
import { SET_PAGE_READY } from '../pages/redux/actions'
import { isContentDetailPage } from '../content'
import { createViewRecords } from '../data'
import {
  GET_DATA_LIST,
  getDataList as getDataListAction,
  setDataList as setDataListAction,
} from '../data/redux/actions'
import { getContentFiltersList as apiGetContentFiltersList } from '.'
import { getConfigDataServer } from '../config'

const log = console
const CONTENT_FILTERS_STORE_KEY = 'contentFilters'

export function getContentFiltersList ({ takeMaybe }) {
  return takeMaybe(GET_DATA_LIST, ({ action, state }) => {
    const { auth, config, data } = state
    const { storeKey, options } = action.payload
    const { contentFilters } = data
    if (contentFilters) {
      return null
    }
    return async () => {
      const generatedContentFilters = await apiGetContentFiltersList({
        auth,
        server: getConfigDataServer(config),
      })
      return setDataListAction({
        storeKey,
        options,
        records: createViewRecords(List(generatedContentFilters.get('contentFilters'))),
        total: generatedContentFilters.get('totalCount'),
      })
    }
  })
    .when(isContentFiltersDataListAction)
    .catch((_options, error) => {
      const msg = 'Error fetching content filters'
      log.error(error, msg)
    })
}

export function contentFiltersData ({ after }) {
  return after(SET_PAGE_READY, ({ dispatch }) => {
    dispatch(getDataListAction({
      storeKey: CONTENT_FILTERS_STORE_KEY,
      processing: true,
    }))
  })
    .when(({ state }) => isContentDetailPage(state))
}

/**
 * Returns true if the action has a storeKey of 'contentFilters'
 * @param {Object} param0 The parameters
 * @param {Object} [param0.action={}] A redux action
 * @param {Object} [param0.action.payload] The action payload
 * @param {String} [param0.action.payload.storeKey] The store key
 * @returns {Boolean} True when store key equals contentFilters
 */
function isContentFiltersDataListAction ({ action = {} } = {}) {
  const { payload: { storeKey } = {} } = action
  return storeKey === CONTENT_FILTERS_STORE_KEY
}
